"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
* Convert current string to snake case
* i.e hello-world will become: hello_world
*
* @return string
*/
function toSnakeCase(string, lowerAll) {
    if (lowerAll === void 0) { lowerAll = true; }
    return string.replace(/(\-|\s|([A-Z]))+/g, function (match, v2, matchedUpperLetter, offset, string) {
        if (!matchedUpperLetter)
            return '_';
        return '_' + (lowerAll ? matchedUpperLetter.toLowerCase() : matchedUpperLetter);
    });
}
exports.default = toSnakeCase;
;
//# sourceMappingURL=toSnakeCase.js.map